export default __webpack_public_path__ + "static/media/universities.2ed473a0.svg";